import { CancelToken } from 'axios'

import { portalApi } from '@/axios'

import { Transaction } from '@/classes/models'

export default class TransactionService {
  /**
   * Get all transactions.
   *
   * @param {Context} context
   * @param {TableRequest} parameters
   *
   * @return {Promise}
   */
  static getAll (context, parameters) {
    const cancelToken = CancelToken.source()

    let request = portalApi.get(this.endpoint(context), {
      cancelToken: cancelToken.token,
      params: parameters ? parameters.getParams(
        (params, sort) => { // Custom sort
          // This should be multifield but it isn't
          if (sort !== null && sort.by) {
            params.OrderingField = sort.by
            params.OrderingDirection = (sort.desc ? 'Descending' : 'Ascending')
          }
        }) : null
    }).then(response => {
      return response.data
    })

    request.then(response => {
      // Set pagination
      response.totalCount = response.numberOfResults

      // Map to Transaction
      response.data = response.results.map(transactions => {
        return new Transaction(transactions)
      })

      return response
    }).catch(error => {
      return Promise.reject(error)
    })

    return { request, cancelToken }
  }

  /**
   * Get all transactions reports.
   *
   * @param {Context} context
   * @param {object} parameters
   *
   * @return {Promise}
   */
  static getAllReports (context, parameters) {
    return portalApi.post(`${this.endpoint(context)}/full/reports`, null, { params: parameters || null })
  }

  /**
   * Get a transaction by id.
   *
   * @param {Context} context
   * @param {string} transactionId
   *
   * @return {Promise}
   */
  static get (context, transactionId, enableHandler = true) {
    return portalApi.get(`${this.endpoint(context)}/${transactionId}`, { enableHandler }).then(response => {
      return response.data
    }).then(response => {
      // Map to Transaction
      return new Transaction(response)
    }).catch(error => {
      return Promise.reject(error)
    })
  }

  /**
   * Get card number for a specific transactions
   *
   * @param {string} transactionId
   *
   * @return {Promise}
   */
  static getCardNumber (context, transactionId, enableHandler = false) {
    return portalApi.get(`${this.endpoint(context)}/${transactionId}/cardNumber`, { enableHandler }).then(response => {
      return response.data
    })
  }

  /**
   * Get masked card number for a specific transactions
   *
   * @param {string} transactionId
   *
   * @return {Promise}
   */
  static getMaskedCardNumber (context, transactionId, enableHandler = false) {
    return portalApi.get(`${this.endpoint(context)}/${transactionId}/maskedCardNumber`, { enableHandler }).then(response => {
      return response.data
    })
  }

  /**
   * Endpoint of API.
   *
   * @param {Context} context
   *
   * @return {string}
   */
  static endpoint (context) {
    if (context === null) {
      return `/transactions`
    } else {
      return `${context.endpoint(['business', 'merchant'])}/transactions`
    }
  }
}
